module.exports = __webpack_public_path__ + "static/media/monitoring.3a1fac87.svg";